import { Device } from './interfaces';
// eslint-disable-next-line import/prefer-default-export
export const getDeviceName = (device: Device, withRoomName: boolean = true) : string => {
  let displayName = device.name ?? (device.hardwareId ? device.hardwareId : device.id);
  if (withRoomName && device.room) {
    displayName += ` (${device.room.name})`;
  }
  return displayName;
};
